module.exports = __webpack_public_path__ + "img/ayandeh.b9b8b4a9.png";